import styled from 'styled-components'
import Div100vh from 'react-div-100vh'

export default styled(Div100vh)`
  /* width: 100vw;
  overflow-x: hidden;
  height: 100vh; */
`
